import axiosInstance from "../../api/axiosInstance";

export const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async (args) => {
    try {
      const result = await axiosInstance({
        url: baseUrl + args.url,
        method: args.method,
        data: args.body,
        params: args.params,
        ...args,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
